import $ from 'jquery';

$(document).ready(() => {
	var $select = $('[data-js="selectSubmit"]');

	$select.on('change',onChange);

	function onChange(){
		$(this).parents('form').submit();
	}
})
